import React from 'react';

export const VerticalSeparatorLine = () => {
    return (
        <svg width="2" height="35" viewBox="0 0 2 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.705078 0.523438V34.3668" stroke="#E5E5E5" stroke-width="1.29401"/>
        </svg>
    )
}